import { createWebHistory } from 'vue-router';

import environment from '@/services/environment';

export default createWebHistory(`/${environment()}`);
